import { TChatDataInListSchema } from '../../types/chatList';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EArchivedListActionTypes {
  SetPending = 'chats/archivedList/setPending',
  SetSucceed = 'chats/archivedList/setSucceed',
  SetFailed = 'chats/archivedList/setFailed',
}

export interface IArchivedListRequest {
  // timestamp последнего чата, последней страницы
  timestampArchive?: number;
}

export type TArchivedListActions =
  | ITypedReduxAction<EArchivedListActionTypes.SetPending, IArchivedListRequest>
  | ITypedReduxAction<EArchivedListActionTypes.SetSucceed, TChatDataInListSchema[]>
  | ITypedReduxAction<EArchivedListActionTypes.SetFailed, void>;
